import { useQuery } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import { OWNER_PAYOUT_PROJECTION_QUERY_KEY } from "./constants";
import type { OwnerPayoutProjection } from "./types";

/**
 * Hand-written fetch — see CLAUDE.md → TD-07. `GET …/venue-owners/:userId/
 * payouts/projected` (API-FIN-8) — the owner's next-payout projection.
 * With no activity: amounts 0, `currency: null`, but `nextPayoutDate` is never
 * null (always the first of next month, UTC).
 */
export function useOwnerPayoutProjection(userId: string) {
  return useQuery({
    queryKey: [...OWNER_PAYOUT_PROJECTION_QUERY_KEY, userId] as const,
    queryFn: () =>
      httpClient<OwnerPayoutProjection>(
        `/api/admin/venue-owners/${encodeURIComponent(userId)}/payouts/projected`,
      ),
    enabled: userId.length > 0,
    staleTime: 30_000,
  });
}
